// @flow

import React, { PureComponent } from 'react';
import glamorous from 'glamorous';
import { padding } from 'polished';
import Avatar from 'app/components/commons/Avatar';
import vipIcon from 'app/images/globalLeaderboard/blue-tick.svg';

type Props = {
  avatar?: Object,
  countryFlag: string,
  entryCount?: number,
  friendStatus?: number,
  isVIP?: boolean,
  name: string,
};

const Row = glamorous.div(({ theme }) => ({
  borderColor: 'rgba(100, 100, 100, 0.25)',
  borderStyle: 'solid',
  borderTopWidth: 0,
  borderRightWidth: 0,
  borderBottomWidth: 1,
  borderLeftWidth: 0,
  display: 'flex',
  fontSize: theme.fontSize.xsmall,
  marginBottom: 2,
  overflow: 'hidden',
  ...padding(5, 10),
  position: 'relative',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

const Entrant = glamorous.div({
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 12,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

class EntrantRow extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    avatar: undefined,
    entryCount: 0,
    friendStatus: undefined,
    isVIP: false,
  };

  render() {
    const { avatar, countryFlag, entryCount, friendStatus, isVIP, name } = this.props;

    return (
      <Row>
        <Avatar avatar={avatar} size="xsmall" status={friendStatus} countryFlag={countryFlag} />
        <Entrant>
          {name}
          {isVIP && (
            <span>
              {' '}
              <img src={vipIcon} alt="" />
            </span>
          )}
          {entryCount > 1 && (
            <span> ({entryCount})</span>
          )}
        </Entrant>
      </Row>
    );
  }
}

export default EntrantRow;
